/* Ability Warehouse product page: one price, membership bar, info popups, collapsibles, sticky section bar, fit story specs, sticky add-to-cart bar */
(function () {
  'use strict';
  var root = document.querySelector('[data-pdp]');
  if (!root) return;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var money = function (c) { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format((c || 0) / 100); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); };
  var headerH = function () { return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 0; };

  /* ---------- price, quantity, membership ---------- */
  var form = $('form[data-calc]');
  var qtyEl = form && form.querySelector('input[name="quantity"]');
  var addBtn = form && form.querySelector('[data-add]');
  var tog = $('[data-tog-input]'), panel = $('[data-member-panel]'), cap = $('[data-mem-cap]'), under = $('[data-under]');
  var noSale = root.dataset.noSale === 'true';
  var locked = !noSale && root.dataset.locked === 'true';
  var salePct = +root.dataset.salePct || 0, memberPct = +root.dataset.memberPct || 10;
  var state = { base: +root.dataset.base || 0, available: !(addBtn && addBtn.disabled), save: 0 };
  function qty() { return Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1); }
  function guestUnit() { return Math.round(state.base * (100 - salePct) / 100); }
  function memberUnit() { return noSale ? guestUnit() : Math.round(state.base * (100 - memberPct) / 100); }
  function memberOn() { return !noSale && (locked || !!(tog && tog.checked)); }
  function render() {
    var n = qty(), g = guestUnit(), m = memberUnit(), on = memberOn();
    var shown = (on ? m : g) * n;
    state.save = Math.max(0, g - m) * n;
    /* Prominent price block: member price (red) and the plainly-labelled standard price, kept in sync on variant change */
    var pm = $('[data-price-member]'); if (pm) pm.textContent = money(m);
    var pstd = $('[data-price-standard]'); if (pstd) pstd.textContent = money(g);
    /* Price lives on the Add to cart button: struck-through normal price + member price when ticked, normal price when not */
    var bt = $('[data-btn-total]'); if (bt) bt.textContent = money(shown);
    var bo = $('[data-btn-old]'); if (bo) { bo.textContent = money(g * n); bo.hidden = !on || g <= m; }
    var pp = $('[data-add-pp]'); if (pp) pp.hidden = !state.available;
    var at = $('[data-add-text]'); if (at) at.textContent = state.available ? 'Add to cart' : 'Sold out';
    /* Sticky bar mirrors the same state */
    var bt2 = $('[data-bar-tot]'); if (bt2) bt2.textContent = money(shown);
    var bw = $('[data-bar-was]'); if (bw) { bw.textContent = money(g * n); bw.hidden = !on || g <= m; }
    var bpp = $('[data-bar-pp]'); if (bpp) bpp.hidden = !state.available;
    var bat = $('[data-bar-add-text]'); if (bat) bat.textContent = state.available ? 'Add to cart' : 'Sold out';
    var br = $('[data-bar-r]'); if (br) br.textContent = locked ? '✓ Member price applied' : on ? '✓ SAVE ' + money(state.save) : 'Tick to save ' + money(state.save);
    var bm2 = $('[data-bar-m]'); if (bm2) bm2.classList.toggle('is-on', on);
    var btg = $('[data-bar-tog]'); if (btg) btg.checked = on;
    var bq = $('[data-bar-q]'); if (bq) bq.textContent = n;
    $$('[data-member-save], [data-cap-save]').forEach(function (el) { el.textContent = money(state.save); });
    if (panel) panel.classList.toggle('is-on', on);
    var mc = $('[data-mb-cap]'); if (mc) mc.textContent = locked ? '✓ Member price applied' : on ? '✓ Added' : 'Tick to';
    if (cap) { cap.hidden = locked; cap.classList.toggle('is-on', on); }
    if (under) under.hidden = !(on && !locked);
    var fp = $('[data-faq-price]'); if (fp) fp.textContent = money(g);
    $$('[data-awq-price]').forEach(function (el) { el.setAttribute('data-awq-price', money(g)); });
    var st = $('[data-stock]');
    if (st) { st.textContent = state.available ? 'In stock' : 'Sold out'; st.classList.toggle('is-in', state.available); st.classList.toggle('is-out', !state.available); }
    var dsp = $('[data-dispatch]'); if (dsp) dsp.hidden = !state.available;
    var ba = $('[data-bar-add]'); if (ba) ba.disabled = !state.available;
    if (addBtn) addBtn.disabled = !state.available;
  }
  if (form) form.addEventListener('input', function (e) { if (e.target === qtyEl) render(); });
  document.addEventListener('click', function (e) { if (e.target.closest('[data-qty-step]')) setTimeout(render, 0); });
  document.addEventListener('aw:variant', function (e) {
    var v = e.detail || {};
    if (v.id) { state.base = +v.price || state.base; state.available = v.available !== false; }
    setTimeout(render, 0); setTimeout(pinTall, 50);
  });
  if (tog) tog.addEventListener('change', function () { render(); setTimeout(pinTall, 50); });

  /* ---------- Info popups: a /pages/* page's main content in a rounded dialog ----------
     Links with data-popup / data-mem-open, plus any in-content /pages/* link in the buy card, Delivery & funding,
     Member benefits and Questions panels. No popup for external links, new-tab links, or the quote/contact flows.
     Falls back to the plain link when the page cannot be loaded or <dialog> is unsupported. */
  var modal = $('[data-popup-modal]'), modalBody = $('[data-mem-body]'), modalTitle = $('[data-popup-title]', modal || root), cache = {}, curSrc = '';
  var POP_AREAS = '.pdp-b--buy, .pdp-b--delivery, .pdp-b--funding, .pdp-b--member, .pdp-b--faq';
  var NO_POP = /^\/pages\/(quote|contact|trade|providers)\b/;
  function popLink(a) {
    if (!a || a.target === '_blank' || a.hasAttribute('data-no-popup') || a.hasAttribute('data-awq-open')) return null;
    var href = a.getAttribute('href') || '';
    var u; try { u = new URL(href, location.href); } catch (e) { return null; }
    if (u.origin !== location.origin || !/^\/pages\//.test(u.pathname) || NO_POP.test(u.pathname)) return null;
    if (u.search && /callback|product=/.test(u.search)) return null;
    if (a.hasAttribute('data-popup') || a.hasAttribute('data-mem-open') || a.closest(POP_AREAS)) return u;
    return null;
  }
  function popFallback(src) { modalBody.innerHTML = '<p class="pdp-modal__msg">We could not load the details here. <a href="' + esc(src) + '" data-no-popup>Open the page</a>.</p>'; }
  function extract(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var title = '', wrapEl;
    var mem = doc.querySelector('[data-mem]');
    if (mem) { wrapEl = mem.closest('.shopify-section') || mem.parentNode; $$('[data-mem-bar]', wrapEl).forEach(function (b) { b.remove(); }); }
    else { wrapEl = doc.querySelector('main#MainContent, main, [role=main]'); if (!wrapEl) throw new Error('no main'); }
    $$('header, footer, .shopify-section-group-header-group, .shopify-section-group-footer-group, [data-cart-drawer], .crumbs', wrapEl).forEach(function (x) { if (x !== wrapEl) x.remove(); });
    $$('h1', wrapEl).forEach(function (h) { if (!title) title = h.textContent.trim(); var h2 = doc.createElement('h2'); h2.className = h.className; h2.innerHTML = h.innerHTML; h.replaceWith(h2); });
    if (!title) title = (doc.title || '').split(/\s[–|-]\s/)[0].trim();
    var scripts = $$('script', wrapEl).filter(function (s) { return !s.src && !/json/.test(s.type || ''); }).map(function (s) { var t = s.textContent; s.remove(); return t; });
    $$('script', wrapEl).forEach(function (s) { if (s.src) s.remove(); });
    return { title: title, nodes: Array.prototype.slice.call(wrapEl.childNodes), scripts: scripts };
  }
  function loadPopup(u, label) {
    var src = u.pathname + u.search;
    if (modalTitle) modalTitle.textContent = label || 'Details';
    if (curSrc === src && modalBody.dataset.loaded === '1') { jump(u.hash); return; }
    curSrc = src; modalBody.dataset.loaded = '0';
    modalBody.innerHTML = '<p class="pdp-modal__msg">Loading…</p>';
    (cache[src] || (cache[src] = fetch(src, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })))
      .then(function (html) {
        if (curSrc !== src) return;
        var x = extract(html);
        if (modalTitle && !label && x.title) modalTitle.textContent = x.title;
        modalBody.innerHTML = '';
        x.nodes.forEach(function (n) { modalBody.appendChild(document.importNode(n, true)); });
        x.scripts.forEach(function (t) { var s = document.createElement('script'); s.textContent = '(function(){try{' + t + '\n}catch(e){}})();'; modalBody.appendChild(s); });
        modalBody.dataset.loaded = '1'; modalBody.scrollTop = 0; modal.scrollTop = 0;
        jump(u.hash);
      }).catch(function () { delete cache[src]; curSrc = ''; popFallback(src + (u.hash || '')); });
  }
  function jump(hash) { if (!hash || hash.length < 2) return; var t = null; try { t = modalBody.querySelector(hash); } catch (e) {} if (t) setTimeout(function () { t.scrollIntoView({ block: 'start' }); }, 30); }
  if (modal && modalBody && typeof modal.showModal === 'function') {
    var lastFocus = null;
    var openPopup = function (u, label) {
      lastFocus = document.activeElement;
      loadPopup(u, label);
      if (!modal.open) modal.showModal();
      document.documentElement.classList.add('pdp-modal-open');
      var x = $('[data-mem-close]', modal); if (x) x.focus();
    };
    var closeModal = function () { if (modal.open) modal.close(); };
    modal.addEventListener('close', function () { document.documentElement.classList.remove('pdp-modal-open'); if (lastFocus && lastFocus.focus) lastFocus.focus(); });
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-mem-close]')) { closeModal(); return; }
      if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest('a[href]'); if (!a) return;
      if (!root.contains(a) && !a.hasAttribute('data-mem-open')) return;
      var u = popLink(a); if (!u) return;
      e.preventDefault(); e.stopPropagation();
      var label = a.getAttribute('data-popup-title') || (a.hasAttribute('data-mem-open') ? 'How membership works' : '');
      openPopup(u, label);
    }, true);
  }

  /* Guest with the box ticked: one /cart/add.js call for the product and the monthly membership (same selling plan the cart uses), then the new-member code. Members and carts that already hold a membership submit normally. */
  function addItems(items) {
    return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); });
  }
  function drawerMsg(html, type) {
    var m = document.querySelector('[data-cart-drawer] [data-cd-msg]');
    if (m) { m.className = 'cd__msg' + (type ? ' cd__msg--' + type : ''); m.innerHTML = html; }
  }
  if (form && tog && !locked && !noSale) {
    form.addEventListener('submit', function (e) {
      if (!tog.checked) return;
      e.preventDefault(); e.stopPropagation();
      var fd = new FormData(form), n = qty();
      var line = { id: +fd.get('id'), quantity: n };
      var sp = fd.get('selling_plan'); if (sp) line.selling_plan = +sp;
      var old = addBtn.innerHTML; addBtn.disabled = true; addBtn.classList.add('is-loading'); addBtn.textContent = 'Adding…';
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).catch(function () { return { items: [] }; }).then(function (cart) {
        var has = (cart.items || []).some(function (i) { return i.handle === 'membership'; });
        var items = [line];
        if (!has && root.dataset.mv) items.push({ id: +root.dataset.mv, quantity: 1, selling_plan: +root.dataset.plan || undefined, properties: { Promo: root.dataset.freeMonth === 'true' ? '2 months free membership' : 'First month free' } });
        return addItems(items);
      }).then(function () {
        return fetch('/discount/' + encodeURIComponent(root.dataset.code || 'NEWMEMBER') + '?redirect=%2Fcart', { credentials: 'same-origin' }).catch(function () {});
      }).then(function () {
        if (window.CWCart) return window.CWCart.refresh().then(function () { drawerMsg('<span class="cd__tick" aria-hidden="true">✓</span> Added ' + (n > 1 ? n + ' × ' : '') + esc(($('.pdp-title') || {}).textContent || 'Item') + ' with membership', 'ok'); window.CWCart.open(); });
        location.href = '/cart';
      }).catch(function (err) { alert(err.message || 'Sorry, that could not be added.'); })
        .then(function () { addBtn.disabled = !state.available; addBtn.classList.remove('is-loading'); addBtn.innerHTML = old; render(); });
    });
  }

  /* ---------- sticky section bar: scroll-spy + smooth scroll ---------- */
  var sbar = $('[data-sbar]');
  if (sbar) {
    var links = $$('a', sbar), targets = [];
    links.forEach(function (a) { var t = document.querySelector(a.getAttribute('href')); if (t) targets.push({ a: a, el: t }); else a.hidden = true; });
    var offset = function () { return headerH() + sbar.offsetHeight + 12; };
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.querySelector(a.getAttribute('href')); if (!t) return;
        e.preventDefault();
        window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - offset(), behavior: 'smooth' });
        links.forEach(function (l) { l.classList.toggle('is-on', l === a); });
      });
    });
    var spyT = null;
    var spy = function () {
      spyT = null;
      var y = offset() + 24, cur = targets[0];
      targets.forEach(function (t) { if (t.el.getBoundingClientRect().top <= y) cur = t; });
      if (cur) links.forEach(function (l) { l.classList.toggle('is-on', l === cur.a); });
    };
    window.addEventListener('scroll', function () { if (!spyT) spyT = requestAnimationFrame(spy); }, { passive: true });
    spy();
  }

  /* ---------- sticky add-to-cart bar: shows once the buy card has scrolled out of view ----------
     Phones/tablets: the red control adds to cart. Desktop (>=990px): tapping it (except the membership line and the
     options chip) scrolls back to the buy card and focuses the quantity. Tick and quantity drive the buy card's own
     controls — one source of truth. */
  var bar = $('[data-bar]'), barVisible = false;
  var isDesk = function () { return window.innerWidth >= 990; };
  function barPad() { var h = barVisible ? bar.offsetHeight : 0; document.body.style.paddingBottom = h ? h + 'px' : ''; document.documentElement.style.setProperty('--sb-h', h + 'px'); }
  function barShow(on) {
    if (!bar || on === barVisible) return;
    barVisible = on;
    bar.classList.toggle('is-on', on);
    if (on) { bar.removeAttribute('inert'); bar.removeAttribute('aria-hidden'); } else { bar.setAttribute('inert', ''); bar.setAttribute('aria-hidden', 'true'); }
    barPad();
  }
  var buyCard = $('.pdp-b--buy');
  function toBuyCard() {
    var t = buyCard || addBtn; if (!t) return;
    var top = t.getBoundingClientRect().top + window.scrollY - headerH() - 16;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    setTimeout(function () { if (qtyEl) { try { qtyEl.focus({ preventScroll: true }); } catch (e) { qtyEl.focus(); } } }, 500);
  }
  if (bar && addBtn) {
    var watch = $('.pdp-buyunit') || addBtn;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) {
      barShow(!en[0].isIntersecting);
    }, { threshold: 0 }).observe(watch);
    bar.classList.toggle('is-desk', isDesk());
    window.addEventListener('resize', function () { bar.classList.toggle('is-desk', isDesk()); barPad(); });
    var btog = $('[data-bar-tog]');
    if (btog && tog) btog.addEventListener('change', function () { tog.checked = btog.checked; tog.dispatchEvent(new Event('change', { bubbles: true })); });
    bar.addEventListener('click', function (e) {
      if (e.target.closest('[data-bar-m]')) return; /* the membership line toggles on every screen size */
      if (e.target.closest('[data-bar-var]')) return; /* the options chip opens the sheet */
      if (isDesk()) { e.preventDefault(); toBuyCard(); return; }
      var st = e.target.closest('[data-bar-step]');
      if (st && qtyEl) { qtyEl.value = Math.max(1, qty() + parseInt(st.dataset.barStep, 10)); qtyEl.dispatchEvent(new Event('input', { bubbles: true })); return; }
      if (e.target.closest('[data-bar-add]')) { if (addBtn.disabled) return; if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click(); }
    });
  }

  /* ---------- collapsibles (Paying with NDIS or privately? · Before you buy): collapsed by default, animated ---------- */
  $$('[data-col]').forEach(function (c) {
    var btn = $('[data-col-btn]', c), p = $('[data-col-panel]', c); if (!btn || !p) return;
    c.classList.add('is-ready');
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      c.classList.toggle('is-open', open);
    });
  });

  /* ---------- variant chip + bottom sheet: drives the main variant picker ---------- */
  var sheet = $('[data-bar-sheet]'), vpBox = document.querySelector('[data-variant-picker]'), vpData = null;
  if (vpBox) { try { vpData = JSON.parse(vpBox.querySelector('[data-vp-product]').textContent); } catch (e) { vpData = null; } }
  function vpSel() { return $$('[data-vp-opt]', vpBox).map(function (o) { var b = o.querySelector('.topt__btn.is-on'); return b ? b.dataset.vpVal : ''; }); }
  function vpFind(values) { for (var i = 0; i < vpData.variants.length; i++) { var v = vpData.variants[i], ok = true; for (var j = 0; j < values.length; j++) if (v.options[j] !== values[j]) { ok = false; break; } if (ok) return v; } return null; }
  function chipLabel() { var vn = $('[data-bar-vn]'); if (vn && vpData) { var cur = vpFind(vpSel()); if (cur) vn.textContent = cur.title.replace(/ \/ /g, ' · '); } }
  function buildSheet() {
    var body = $('[data-sheet-body]'); if (!body || !vpData) return;
    var sel = vpSel(), html = '', single = vpData.options.length === 1;
    vpData.options.forEach(function (name, i) {
      var vals = [];
      vpData.variants.forEach(function (v) { if (vals.indexOf(v.options[i]) < 0) vals.push(v.options[i]); });
      /* a price per value: the variant you would get with the other options as they are now */
      var prices = vals.map(function (val) { var t = sel.slice(); t[i] = val; var v = vpFind(t); if (!v) { for (var k = 0; k < vpData.variants.length; k++) if (vpData.variants[k].options[i] === val) { v = vpData.variants[k]; break; } } return v ? v.price : null; });
      var differ = prices.some(function (p) { return p !== null && p !== prices[0]; });
      var showP = single || differ;
      html += '<p class="pdp-sheet__lab">' + esc(name) + '</p><div class="pdp-sheet__vl' + (vals.length <= 3 && !showP ? ' pdp-sheet__vl--row' : '') + '" data-sheet-opt="' + i + '">';
      vals.forEach(function (val, k) {
        var t = sel.slice(); t[i] = val; var v = vpFind(t), dead = !v || !v.available;
        html += '<button type="button" aria-pressed="' + (sel[i] === val) + '" data-sheet-val="' + esc(val) + '"' + (dead ? ' class="is-dead"' : '') + '><span class="pdp-sheet__v">' + esc(val) + (dead ? '<small>' + (v ? 'sold out' : 'not available') + (vpData.options.length > 1 ? ' in this combination' : '') + '</small>' : '') + '</span>' + (showP && prices[k] !== null ? '<span class="pdp-sheet__p">' + money(prices[k]) + '</span>' : '') + '</button>';
      });
      html += '</div>';
    });
    body.innerHTML = html;
  }
  if (sheet && vpBox && vpData) {
    var sheetLast = null;
    var sheetOpen = function () { buildSheet(); sheetLast = document.activeElement; sheet.hidden = false; document.documentElement.classList.add('pdp-sheet-open'); var x = $('[data-sheet-close]', sheet); if (x) x.focus(); };
    var sheetClose = function () { if (sheet.hidden) return; sheet.hidden = true; document.documentElement.classList.remove('pdp-sheet-open'); if (sheetLast && sheetLast.focus) sheetLast.focus(); };
    var chip = $('[data-bar-var]'); if (chip) chip.addEventListener('click', sheetOpen);
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet || e.target.closest('[data-sheet-close]')) { sheetClose(); return; }
      var b = e.target.closest('[data-sheet-val]'); if (!b) return;
      var i = +b.closest('[data-sheet-opt]').dataset.sheetOpt, val = b.dataset.sheetVal;
      var opt = $$('[data-vp-opt]', vpBox)[i], target = opt && $$('.topt__btn', opt).filter(function (x) { return x.dataset.vpVal === val; })[0];
      if (target) target.click();
      buildSheet();
      var again = $$('[data-sheet-opt="' + i + '"] [data-sheet-val]', sheet).filter(function (x) { return x.dataset.sheetVal === val; })[0]; if (again) again.focus();
    });
    document.addEventListener('keydown', function (e) {
      if (sheet.hidden) return;
      if (e.key === 'Escape') { sheetClose(); return; }
      if (e.key === 'Tab') {
        var f = $$('button:not([disabled])', sheet); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    document.addEventListener('aw:variant', function () { chipLabel(); if (!sheet.hidden) buildSheet(); });
    chipLabel();
  }

  /* Buy card taller than the viewport: pin its bottom instead, so the Add button stays reachable */
  var buy = $('.pdp-b--buy');
  function pinTall() {
    if (!buy) return;
    buy.style.top = '';
    if (window.innerWidth < 990) return;
    var top = headerH() + 16, h = buy.offsetHeight;
    if (h + top + 16 > window.innerHeight) buy.style.top = (window.innerHeight - h - 16) + 'px';
  }
  window.addEventListener('resize', pinTall); window.addEventListener('load', pinTall);

  /* ---------- specs: metafields first, window.AWSpecs (assets/aw-specs.js) as the fallback ---------- */
  function nums(str) { var m = String(str || '').replace(/,/g, '.').match(/\d+(\.\d+)?/g); return m ? m.map(Number) : []; }
  function range(str) { var n = nums(str); return n.length ? [n[0], n.length > 1 ? n[1] : n[0]] : null; }
  function fmtRange(r) { return r ? (r[0] === r[1] ? r[0] : r[0] + '–' + r[1]) + ' cm' : ''; }
  var NOTE = {
    w: "Choose a rating comfortably above the user's weight, with room for clothing and bags.",
    s: 'Feet flat on the floor when seated. A seat at about knee height is easiest to stand up from.',
    hh: 'Stand tall with arms relaxed — the handles should sit at wrist height.',
    wd: 'Allow about 4 cm of clearance each side of your narrowest doorway.',
    i: 'Lighter is easier to lift into a car boot or carry up a step.',
    wheel: 'Around 20 cm suits paths, shops and home; grass and gravel want 25 cm or bigger.'
  };
  var LBL = { w: ['User weight', 'max user weight', 'Maximum user weight', 'safety'], s: ['Seat height', 'seat height', 'Seat height', 'size'], hh: ['Handle height', 'handle height', 'Handle height', 'size'], wd: ['Width', 'overall width', 'Overall width', 'size'], i: ['Product weight', 'product weight', 'Product weight', 'transport'], wheel: ['Wheels', 'wheels', 'Wheels', 'transport'] };
  var tick = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="3" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>';
  var spec = {};
  function buildSpec() {
    var d = root.dataset, a = (window.AWSpecs || {})[d.handle] || {};
    spec.w = nums(d.spW)[0] || a.w || 0;
    spec.s = range(d.spS) || a.s || null;
    spec.hh = range(d.spHh) || a.hh || null;
    spec.wd = nums(d.spWd)[0] || a.wd || 0;
    spec.i = nums(d.spI)[0] || a.i || 0;
    spec.wheel = nums(d.spWheel)[0] || 0;
    spec.wheelTxt = d.spWheel || '';
  }
  function text(k) {
    if (k === 'w') return spec.w ? 'up to ' + spec.w + ' kg' : '';
    if (k === 's') return fmtRange(spec.s);
    if (k === 'hh') return fmtRange(spec.hh);
    if (k === 'wd') return spec.wd ? spec.wd + ' cm' : '';
    if (k === 'i') return spec.i ? spec.i + ' kg' : '';
    if (k === 'wheel') return spec.wheelTxt;
    return '';
  }
  /* ---------- Description → scannable cards. Only reflows what the description already says. ---------- */
  var DESC_KEY = [
    [/^(max(imum)?\.? ?(user )?weight|weight capacity|user weight|safe working load|load capacity|weight limit|weight rating)$/i, 'w'],
    [/^seat height$/i, 's'], [/^handle height( range)?$/i, 'hh'], [/^(overall width|width)$/i, 'wd'],
    [/^(net weight|product weight|unit weight|weight|item weight)$/i, 'i'], [/^(wheels?|wheel size|castors?)$/i, 'wheel']
  ];
  function descGroup(label) {
    if (/brake|grip|lock|slip|safety/i.test(label)) return 'safety';
    if (/weight|fold|material|frame|tyre|wheel|castor|transport/i.test(label)) return 'transport';
    return 'size';
  }
  function cleanInline(node) {
    /* Keep bold/italic/line breaks and real product links; drop everything else to text */
    var out = '';
    Array.prototype.forEach.call(node.childNodes, function (c) {
      if (c.nodeType === 3) { out += esc(c.nodeValue.replace(/\s+/g, ' ')); return; }
      if (c.nodeType !== 1) return;
      var t = c.tagName.toLowerCase();
      if (t === 'br') { out += '<br>'; return; }
      if (t === 'strong' || t === 'b') { out += '<strong>' + cleanInline(c) + '</strong>'; return; }
      if (t === 'em' || t === 'i') { out += '<em>' + cleanInline(c) + '</em>'; return; }
      if (t === 'a') { var h = c.getAttribute('href') || ''; if (/^\/(products|collections|pages)\//.test(h)) { out += '<a href="' + esc(h) + '">' + cleanInline(c) + '</a>'; return; } }
      out += cleanInline(c);
    });
    return out;
  }
  function splitLong(html) {
    /* Long paragraphs → two or three short ones, split at sentence ends */
    var txt = html.replace(/<[^>]+>/g, '');
    if (txt.length < 340) return [html];
    var parts = html.replace(/([.!?])\s+(?=[A-Z<])/g, '$1\u0001').split('\u0001'), out = [], cur = '';
    parts.forEach(function (p) { if (cur && (cur + ' ' + p).replace(/<[^>]+>/g, '').length > 260) { out.push(cur); cur = p; } else cur = cur ? cur + ' ' + p : p; });
    if (cur) out.push(cur);
    return out;
  }
  function labelValue(text) {
    var m = String(text).trim().match(/^([A-Za-z][A-Za-z0-9 .()\/&'-]{1,40}?)\s*:\s*(.{1,80})$/);
    if (!m || /^(note|tip|warning|please|important)/i.test(m[1])) return null;
    return { label: m[1].replace(/\s+/g, ' ').trim(), value: m[2].trim() };
  }
  function renderDesc() {
    var tpl = $('[data-desc]'), wrap = $('[data-desc-cards]'); if (!tpl || !wrap) return;
    var src = document.createElement('div'); src.innerHTML = tpl.innerHTML;
    var about = $('[data-about-card]', wrap);
    var cards = [], cur = { title: '', items: [] }, specs = [];
    function push() { if (cur.items.length) cards.push(cur); }
    function isHeading(el) {
      var t = el.tagName.toLowerCase();
      if (/^h[1-4]$/.test(t)) return el.textContent.trim().replace(/:\s*$/, '');
      if (t === 'p') { var b = el.querySelector('strong, b'); var tx = el.textContent.trim().replace(/:\s*$/, ''); if (b && tx.length < 90 && b.textContent.trim().replace(/:\s*$/, '') === tx) return tx; }
      return null;
    }
    /* A paragraph-like element (or a run of inline nodes) → paragraph(s) or a "Label: value" spec list */
    function para(el) {
      var html = cleanInline(el).replace(/^(<br>|\s|&nbsp;)+|(<br>|\s|&nbsp;)+$/g, '');
      if (!html.replace(/<[^>]+>/g, '').trim()) return;
      var lines = html.split(/<br>/).map(function (s) { return s.trim(); }).filter(Boolean);
      var lvs = lines.map(function (s) { return labelValue(s.replace(/<[^>]+>/g, '')); });
      if (lines.length > 1 && lvs.filter(Boolean).length === lines.length) { lvs.forEach(function (x) { specs.push(x); }); cur.items.push({ t: 'specs', rows: lvs }); return; }
      if (lines.length === 1 && lvs[0]) specs.push(lvs[0]);
      splitLong(html).forEach(function (h) { cur.items.push({ t: 'p', h: h }); });
    }
    var BLOCK = /^(p|div|section|article|ul|ol|table|h[1-6]|blockquote|pre|hr|figure|img|script|style|iframe|video|form)$/;
    var BLOCK_SEL = 'p,div,section,article,ul,ol,table,h1,h2,h3,h4,h5,h6,blockquote,pre,figure';
    function walk(parent) {
      /* Only block-level children become items; text, links, bold, italic etc. are gathered into one paragraph run */
      var run = document.createElement('div');
      function flush() {
        if (!run.childNodes.length) return;
        var b = run.querySelector('strong, b'), tx = run.textContent.trim().replace(/:\s*$/, '');
        if (b && tx && tx.length < 90 && b.textContent.trim().replace(/:\s*$/, '') === tx) { push(); cur = { title: tx, items: [] }; }
        else para(run);
        run = document.createElement('div');
      }
      Array.prototype.slice.call(parent.childNodes).forEach(function (el) {
        if (el.nodeType === 3) { run.appendChild(el.cloneNode(true)); return; }
        if (el.nodeType !== 1) return;
        var tag = el.tagName.toLowerCase();
        if (!BLOCK.test(tag) && !el.querySelector(BLOCK_SEL)) { run.appendChild(el.cloneNode(true)); return; }
        flush();
        if (tag === 'img' || tag === 'script' || tag === 'style' || tag === 'iframe' || tag === 'hr' || tag === 'video' || tag === 'form') return;
        var head = isHeading(el);
        if (head !== null) { push(); cur = { title: head, items: [] }; return; }
        if (tag === 'div' || tag === 'section' || tag === 'article' || tag === 'blockquote' || tag === 'figure' || tag === 'span') { walk(el); return; }
        if (tag === 'ul' || tag === 'ol') {
          var li = $$('li', el).map(function (l) { return { h: cleanInline(l), lv: labelValue(l.textContent) }; }).filter(function (x) { return x.h.replace(/<[^>]+>/g, '').trim(); });
          var specList = /spec|dimension|measurement|technical/i.test(cur.title) && li.filter(function (x) { return x.lv; }).length >= Math.ceil(li.length / 2);
          li.forEach(function (x) { if (x.lv) specs.push(x.lv); });
          if (specList) { cur.items.push({ t: 'specs', rows: li.map(function (x) { return x.lv || { label: '', value: x.h.replace(/<[^>]+>/g, '') }; }) }); }
          else cur.items.push({ t: 'list', li: li.map(function (x) { return x.h; }) });
          return;
        }
        if (tag === 'table') {
          var rows = $$('tr', el).map(function (tr) { return $$('th, td', tr).map(function (c) { return esc(c.textContent.trim()); }); }).filter(function (r) { return r.join('').trim(); });
          if (rows.length) cur.items.push({ t: 'table', rows: rows });
          return;
        }
        para(el);
      });
      flush();
    }
    walk(src); push();
    /* Leading untitled content joins the About card */
    var lead = cards.length && !cards[0].title ? cards.shift() : { title: '', items: [] };
    /* Paragraphs that sit under a "Key benefits" list are the general intro: they belong in the About card */
    cards.forEach(function (c) { if (/key benefits/i.test(c.title)) { c.items = c.items.filter(function (i) { if (i.t === 'p') { lead.items.push(i); return false; } return true; }); } });
    cards = cards.filter(function (c) { return c.items.length; });
    function itemHTML(it) {
      if (it.t === 'p') return '<p>' + it.h + '</p>';
      if (it.t === 'list') return '<ul class="pdp-ticks pdp-ticks--2">' + it.li.map(function (h) { return '<li>' + tick + '<span>' + h + '</span></li>'; }).join('') + '</ul>';
      if (it.t === 'specs') return '<dl class="pdp-spec pdp-spec--card">' + it.rows.map(function (r) { return r.label ? '<div><dt>' + esc(r.label) + '</dt><dd>' + esc(r.value) + '</dd></div>' : '<div><dd>' + esc(r.value) + '</dd></div>'; }).join('') + '</dl>';
      if (it.t === 'table') return '<div class="pdp-dtable-wrap"><table class="pdp-dtable">' + it.rows.map(function (r, i) { return '<tr>' + r.map(function (c) { return (i === 0 ? '<th scope="col">' : '<td>') + c + (i === 0 ? '</th>' : '</td>'); }).join('') + '</tr>'; }).join('') + '</table></div>';
      return '';
    }
    if (lead.items.length && about) about.insertAdjacentHTML('beforeend', lead.items.map(itemHTML).join(''));
    cards.forEach(function (c) {
      var isSpecCard = c.items.length && c.items.every(function (i) { return i.t === 'specs'; });
      wrap.insertAdjacentHTML('beforeend', '<article class="pdp-dcard' + (isSpecCard ? ' pdp-dcard--specs' : '') + '"><h3 class="pdp-h3">' + esc(c.title) + '</h3>' + c.items.map(itemHTML).join('') + '</article>');
    });
    /* "Label: value" lines fill the spec grid and table where the metafields were empty */
    var d = root.dataset, seen = {};
    var tableEl = $('[data-spec-table]');
    specs.forEach(function (sp) {
      var key = null; DESC_KEY.forEach(function (k) { if (!key && k[0].test(sp.label)) key = k[1]; });
      var ds = { w: 'spW', s: 'spS', hh: 'spHh', wd: 'spWd', i: 'spI', wheel: 'spWheel' }[key];
      if (ds && !d[ds]) d[ds] = sp.value;
      var lk = sp.label.toLowerCase(); if (seen[lk]) return; seen[lk] = 1;
      if (!key && !/\d/.test(sp.value) && !/material|colour|color|tyre|frame|backrest|pack|units?/i.test(sp.label)) return;
      if (!key) {
        var grp = $('[data-grp="' + descGroup(sp.label) + '"] .pdp-grp__g');
        var dupTile = grp && $$('.pdp-sp span', grp).some(function (s) { return s.textContent.trim().toLowerCase() === lk; });
        if (grp && !dupTile) grp.insertAdjacentHTML('beforeend', '<div class="pdp-sp"><span>' + esc(sp.label) + '</span><b>' + esc(sp.value) + '</b></div>');
      }
      if (tableEl) {
        var dupRow = $$('dt', tableEl).some(function (dt) { return dt.textContent.trim().toLowerCase() === lk; });
        if (!dupRow) tableEl.insertAdjacentHTML('beforeend', '<div><dt>' + esc(sp.label) + '</dt><dd>' + esc(sp.value) + '</dd></div>');
      }
    });
    tpl.remove();
  }

  /* Add what the page could not render from metafields */
  function fillSpecs() {
    try { renderDesc(); } catch (e) { var t = $('[data-desc]'), w = $('[data-desc-cards]'); if (t && w) { w.insertAdjacentHTML('beforeend', '<article class="pdp-dcard"><div class="rte pdp-prose">' + t.innerHTML + '</div></article>'); t.remove(); } }
    buildSpec();
    var facts = $('[data-fit-facts]'), ks = $('[data-keyspecs]'), table = $('[data-spec-table]');
    ['w', 's', 'hh', 'wd', 'i', 'wheel'].forEach(function (k) {
      var txt = text(k); if (!txt) return;
      var plain = txt.replace(/^up to /, '');
      if (facts && k !== 'hh' && k !== 'wheel' && !facts.querySelector('[data-fact="' + k + '"]')) { facts.insertAdjacentHTML('beforeend', '<div data-fact="' + k + '"><span>' + LBL[k][0] + '</span><b>' + tick + esc(txt) + '</b></div>'); facts.hidden = false; }
      if (ks && k !== 'hh' && k !== 'wheel' && !ks.querySelector('[data-ks="' + k + '"]')) { ks.insertAdjacentHTML('beforeend', '<div data-ks="' + k + '"><b>' + esc(plain) + '</b><span>' + LBL[k][1] + '</span></div>'); ks.hidden = false; }
      var grp = $('[data-grp="' + LBL[k][3] + '"] .pdp-grp__g');
      if (grp && !grp.querySelector('[data-k="' + k + '"]')) grp.insertAdjacentHTML('afterbegin', '<div class="pdp-sp" data-k="' + k + '"><span>' + LBL[k][2] + '</span><b>' + esc(plain) + '</b><small>' + NOTE[k] + '</small></div>');
      if (table && !table.querySelector('[data-spec="' + k + '"]')) {
        var dup = $$('dt', table).some(function (dt) { return dt.textContent.trim().toLowerCase() === LBL[k][2].toLowerCase(); });
        if (!dup) table.insertAdjacentHTML('beforeend', '<div data-spec="' + k + '"><dt>' + LBL[k][2] + '</dt><dd>' + esc(plain) + '</dd></div>');
      }
    });
    $$('[data-grp]').forEach(function (g) { g.hidden = !g.querySelector('.pdp-sp'); });
    initFit();
  }

  /* "Is it right for you?" */
  function initFit() {
    var fp = $('[data-fitpanel]'); if (!fp) return;
    if (!(spec.w || spec.s || spec.hh || spec.wd)) { fp.hidden = true; return; }
    var doorChip = $('[data-door-chip]', fp), doorQ = $('[data-doorq]', fp), doorIn = $('[data-door-in]', fp);
    if (doorChip) doorChip.hidden = !spec.wd;
    if (doorIn) doorIn.addEventListener('input', function () { run(); });
    fp.hidden = false;
    var h = $('[data-h]', fp), w = $('[data-w]', fp), verd = $('[data-verd]', fp), sc = $('[data-score]', fp), st = $('[data-score-t]', fp), where = $$('[data-where] button', fp);
    var seatFor = function (cm) { return Math.round(cm * 0.25 + 3); }, wristFor = function (cm) { return Math.round(cm * 0.48); };
    where.forEach(function (b) { b.addEventListener('click', function () { b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') !== 'true' ? 'true' : 'false'); run(); }); });
    function run() {
      var hv = +h.value, wv = +w.value;
      $('[data-h-out]', fp).textContent = hv + ' cm'; $('[data-w-out]', fp).textContent = wv + ' kg';
      var sel = where.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; }).map(function (b) { return b.dataset.v; });
      if (doorQ) doorQ.hidden = sel.indexOf('door') < 0 || !spec.wd;
      var items = [];
      if (spec.hh) { var wr = wristFor(hv), lo = spec.hh[0], hi = spec.hh[1]; items.push(wr >= lo - 2 && wr <= hi + 2 ? { ok: 1, k: 'hh', t: 'Handle height: wrist sits at about ' + wr + ' cm — inside the ' + fmtRange(spec.hh) + ' range.' } : { ok: 0, k: 'hh', t: 'Handle height: wrist at about ' + wr + ' cm is outside ' + fmtRange(spec.hh) + ' — look at a ' + (wr < lo ? 'lower' : 'taller') + ' model.' }); }
      if (spec.s) { var k = seatFor(hv), slo = spec.s[0], shi = spec.s[1]; items.push(k >= slo - 14 && k <= shi + 10 ? { ok: 1, k: 's', t: 'Seat height ' + fmtRange(spec.s) + ' suits their height (knee about ' + k + ' cm).' } : { ok: 0, k: 's', t: 'Seat height ' + fmtRange(spec.s) + ' may be ' + (k < slo - 14 ? 'too high' : 'too low') + ' — check knee-to-floor height (about ' + k + ' cm).' }); }
      if (spec.w) items.push(wv <= spec.w * 0.88 ? { ok: 1, k: 'w', t: 'Weight rating ' + spec.w + ' kg has a comfortable margin (' + (spec.w - wv) + ' kg).' } : wv <= spec.w ? { ok: 0, k: 'w', t: 'Close to the ' + spec.w + ' kg rating — consider a higher-rated model.' } : { ok: 0, k: 'w', t: 'Over the ' + spec.w + ' kg rating — choose a heavier-duty model.' });
      if (sel.indexOf('home') >= 0 && sel.indexOf('door') < 0 && spec.wd) items.push(spec.wd <= 74 ? { ok: 1, k: 'wd', t: spec.wd + ' cm wide — fits a standard internal doorway (tick “Through a narrow doorway” to check yours).' } : { ok: 0, k: 'wd', t: spec.wd + ' cm wide — tick “Through a narrow doorway” and enter yours; it may be tight.' });
      if (spec.wheel) {
        if (sel.indexOf('rough') >= 0) items.push(spec.wheel >= 25 ? { ok: 1, k: 'wheel', t: spec.wheel + ' cm wheels handle grass and gravel.' } : { ok: 0, k: 'wheel', t: 'Grass & gravel: ' + spec.wheel + ' cm wheels are for paths and shops — pick a larger-wheeled outdoor model.' });
        else if (sel.indexOf('shops') >= 0) items.push(spec.wheel >= 15 ? { ok: 1, k: 'wheel', t: spec.wheel + ' cm wheels suit shops, footpaths and kerb ramps.' } : { ok: 0, k: 'wheel', t: spec.wheel + ' cm wheels are best indoors — footpaths may be bumpy.' });
      } else if (sel.indexOf('rough') >= 0) items.push({ ok: 0, k: 'wheel', t: 'Grass & gravel: check the wheel size with us first — small wheels struggle off paths.' });
      if (sel.indexOf('door') >= 0 && spec.wd && doorIn && +doorIn.value) { var dw = +doorIn.value; items.push(dw >= spec.wd + 8 ? { ok: 1, k: 'wd', t: 'Doorway ' + dw + ' cm: fits with about ' + Math.round((dw - spec.wd) / 2) + ' cm each side (it is ' + spec.wd + ' cm wide).' } : { ok: 0, k: 'wd', t: 'Doorway ' + dw + ' cm is tight — it is ' + spec.wd + ' cm wide and needs about 4 cm each side (' + (spec.wd + 8) + ' cm). Call us about a narrower option.' }); }
      if (sel.indexOf('car') >= 0 && spec.i) items.push(spec.i <= 12 ? { ok: 1, k: 'i', t: 'Car: ' + spec.i + ' kg — lifts into most boots.' } : { ok: 0, k: 'i', t: 'Car: ' + spec.i + ' kg is a two-person lift for most people.' });
      verd.innerHTML = items.map(function (i) { return '<div class="pdp-v' + (i.ok ? '' : ' is-warn') + '"><i>' + (i.ok ? '✓' : '!') + '</i><span>' + esc(i.t) + '</span></div>'; }).join('');
      var okn = items.filter(function (i) { return i.ok; }).length;
      sc.textContent = okn + '/' + items.length;
      st.textContent = !items.length ? 'Tell us a little more' : okn === items.length ? 'Good fit on every check' : okn >= items.length - 1 ? 'Good fit — one thing to check' : 'Probably not the right one — call us';
      $$('.pdp-sp[data-k]').forEach(function (s) { var it = items.filter(function (i) { return i.k === s.dataset.k; })[0]; s.classList.toggle('is-hi', !!(it && !it.ok)); });
    }
    h.addEventListener('input', run); w.addEventListener('input', run); run();
  }

  if (document.readyState === 'complete') fillSpecs(); else window.addEventListener('DOMContentLoaded', fillSpecs);

  /* App blocks that render nothing visible (e.g. the subscriptions widget on a product without plans) */
  $$('.pdp-app').forEach(function (a) { if (!a.innerText.trim() && !a.querySelector('input, select, button, img')) a.hidden = true; });

  render();
  pinTall();
})();
